import React from "react";
import { Orbit, Mountain, Columns2 } from "lucide-react";

const MODES = [
  { id: "aerial", label: "Aerial Macro", icon: Orbit },
  { id: "ground", label: "Ground Micro", icon: Mountain },
  { id: "split", label: "Dual-View", icon: Columns2 },
];

export default function ViewportSwitcher({ value, onChange }) {
  return (
    <div className="viewport-switch" data-testid="viewport-mode-switcher" role="tablist">
      {MODES.map((m) => {
        const Icon = m.icon;
        const active = value === m.id;
        return (
          <button
            key={m.id}
            data-testid={`viewport-${m.id}`}
            onClick={() => onChange(m.id)}
            className={`vp-btn ${active ? "vp-active" : ""}`}
            aria-selected={active}
          >
            <Icon size={15} strokeWidth={1.8} />
            <span className="hidden sm:inline">{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}
